<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { p1Api } from '@/lib/p1-api';

const router = useRouter();
const route = useRoute();
const isOperations = computed(() => route.name === 'ops-login');
const username = ref('');
const password = ref('');
const error = ref('');
const loading = ref(false);
async function submit() {
  loading.value = true;
  error.value = '';
  try {
    const session = isOperations.value
      ? await p1Api.localLogin(username.value, password.value)
      : await p1Api.login(username.value, password.value);
    sessionStorage.setItem('hsl-ems-csrf', session.csrfToken);
    await router.push(
      session.mustChangePassword
        ? '/change-password'
        : isOperations.value
          ? '/admin'
          : '/documents',
    );
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : '登录失败';
  } finally {
    loading.value = false;
  }
}
async function wecomLogin() {
  error.value = '';
  try {
    const { authorizeUrl } = await p1Api.wecomAuthorize();
    window.location.assign(authorizeUrl);
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : '企业微信登录暂不可用';
  }
}
</script>

<template>
  <main class="auth-layout">
    <section class="auth-panel">
      <RouterLink class="back-link" to="/">← 返回首页</RouterLink>
      <p class="phase">{{ isOperations ? '隐藏运维入口' : '郎报通 · 账号登录' }}</p>
      <h1>登录郎报通</h1>
      <p class="form-note">
        {{
          isOperations
            ? '仅限 PLATFORM_ADMIN 应急运维，默认不具备业务数据权限。'
            : '业务用户可使用账号密码登录；已匹配企业微信手机号的账号也可免密登录。'
        }}
      </p>
      <form @submit.prevent="submit">
        <label
          >用户名<input v-model="username" autocomplete="username" required minlength="3"
        /></label>
        <label
          >密码<input
            v-model="password"
            type="password"
            autocomplete="current-password"
            required
            minlength="12"
        /></label>
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
        <button type="submit" :disabled="loading">{{ loading ? '正在验证…' : '安全登录' }}</button>
        <button v-if="!isOperations" class="secondary-button" type="button" @click="wecomLogin">
          企业微信免密登录
        </button>
      </form>
    </section>
  </main>
</template>
